import { createApp } from 'vue';
import Map from '@/components/map/map.vue';
import { parseA11yLabels } from '@/lib/a11y_labels';

const el = '#places-map';
const { dataset } = document.querySelector(el);

const app = createApp(Map, {
  class: 'h-full',
  places: JSON.parse(dataset.places),
  activity: dataset.activity,
  coords: dataset.coords ? JSON.parse(dataset.coords) : null,
});

app.provide('a11yLabels', parseA11yLabels(dataset, 'places_unique_map'));

app.mount(el);
